
import { ReactComponent as TwoPeople } from '../../../components/icons/two-people.svg';
import { ReactComponent as SearchIcon } from '../../../components/icons/search.svg';
import { ReactComponent as Trainings } from '../../../components/icons/vid-oct.svg';

import { ReactComponent as NumSort } from '../../../components/icons/num-sort.svg';
import { ReactComponent as AlphaSort } from '../../../components/icons/alpha-sort.svg';
import SortArrows from '../../../components/icons/sort-arrows.jsx';
import CustomButton from '../../../components/components/custom_button/customButton.jsx';
import CustomInput from '../../../components/components/custom_input/customInput.jsx';

import { clearCheckedItemsT, toggleNeedRefreshT, setKeywordT, setSearchValueT, setSortListEndpointT } from '../../../store/opinionsTTabSlice';
import ApiService from '../../../components/api_services/apiService';

// Akcje dla tabeli
export const actions = {
  changeTab: (tabName, dispatch, setActiveTab) => {
    console.log('Zmieniono zakładkę na:', tabName);
    dispatch(setActiveTab(tabName));
  },
};

// Konfiguracja nagłówków tabeli

export const getHeaders = (sortBy, sortDirection, dispatch, setSorting, sortArrowColorActive, sortArrowColorInactive, rows, checkedItems) => [
  <input
    type="checkbox"
    checked={rows.every((row) => checkedItems.includes(row[1]))}
    onChange={(e) => {
      if (e.target.checked) {
        // Dodaj wszystkie widoczne elementy do checkedItems
        rows.forEach((row) => {
          if (!checkedItems.includes(row[1])) {
            dispatch({ type: 'opinionsT/toggleCheckedItem', payload: row[1] });
          }
        });
      } else {
        // Usuń wszystkie widoczne elementy z checkedItems
        rows.forEach((row) => {
          if (checkedItems.includes(row[1])) {
            dispatch({ type: 'opinionsT/toggleCheckedItem', payload: row[1] });
          }
        });
      }
    }}
    />,
    <div className="table-columns-headers">
    <div>ID</div>
    <SortArrows
      upColor={sortBy === 'id' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'id' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'id') {
          dispatch(setSorting({ sortBy: 'id', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'id', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Data dodania</div>
    <SortArrows
        upColor={sortBy === 'addedOn' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
        downColor={sortBy === 'addedOn' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
        className="menu-icon"
        onClick={() => {
          if (sortBy !== 'addedOn') {
            dispatch(setSorting({ sortBy: 'addedOn', sortDirection: 'ASC' }));
          } else {
            if (sortDirection === 'ASC') {
              dispatch(setSorting({ sortBy: 'addedOn', sortDirection: 'DESC' }));
            } else {
              dispatch(setSorting({ sortBy: null, sortDirection: null }));
            }
          }
        }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Nazwa ocenianego treningu</div>
    <SortArrows
        upColor={sortBy === 'trainingId' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
        downColor={sortBy === 'trainingId' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
        className="menu-icon"
        onClick={() => {
          if (sortBy !== 'trainingId') {
            dispatch(setSorting({ sortBy: 'trainingId', sortDirection: 'ASC' }));
          } else {
            if (sortDirection === 'ASC') {
              dispatch(setSorting({ sortBy: 'trainingId', sortDirection: 'DESC' }));
            } else {
              dispatch(setSorting({ sortBy: null, sortDirection: null }));
            }
          }
        }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Partner treningowy</div>
    <SortArrows
      upColor={sortBy === 'userId' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'userId' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'userId') {
          dispatch(setSorting({ sortBy: 'userId', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'userId', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Sport</div>
    <SortArrows
      upColor={sortBy === 'sportId' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'sportId' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'sportId') {
          dispatch(setSorting({ sortBy: 'sportId', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'sportId', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,

  <div className="table-columns-headers">
    <div>Poziom treningu</div>
    <SortArrows
        upColor={sortBy === 'scoreLevel' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
        downColor={sortBy === 'scoreLevel' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
        className="menu-icon"
        onClick={() => {
          if (sortBy !== 'scoreLevel') {
            dispatch(setSorting({ sortBy: 'scoreLevel', sortDirection: 'ASC' }));
          } else {
            if (sortDirection === 'ASC') {
              dispatch(setSorting({ sortBy: 'scoreLevel', sortDirection: 'DESC' }));
            } else {
              dispatch(setSorting({ sortBy: null, sortDirection: null }));
            }
          }
        }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Osoba wystawiająca</div>
    <SortArrows
        upColor={sortBy === 'opinionSenderId' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
        downColor={sortBy === 'opinionSenderId' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
        className="menu-icon"
        onClick={() => {
          if (sortBy !== 'opinionSenderId') {
            dispatch(setSorting({ sortBy: 'opinionSenderId', sortDirection: 'ASC' }));
          } else {
            if (sortDirection === 'ASC') {
              dispatch(setSorting({ sortBy: 'opinionSenderId', sortDirection: 'DESC' }));
            } else {
              dispatch(setSorting({ sortBy: null, sortDirection: null }));
            }
          }
        }}
    />
  </div>,
];

export const emptyT = [];

// Szerokości kolumn
export const headerWidths = ['42px', '65px', '160px', '2fr', '2fr', '180px', '180px', '2fr'];

// Konfiguracja zakładek
export const tabsConfigT = (activeTab, dispatch, setActiveTab) => [
  {
    icon: TwoPeople,
    name: 'Opinie o użytkownikach',
    hoverClass: 'hover-effect',
    activeClass: activeTab === 'Opinie o użytkownikach' ? 'is-active' : '',
    onClick: () => actions.changeTab('Opinie o użytkownikach', dispatch, setActiveTab),
    toggleActive: true,
  },
  {
    icon: Trainings,
    name: 'Opinie o treningach',
    hoverClass: 'hover-effect',
    activeClass: activeTab === 'Opinie o treningach' ? 'is-active' : '',
    onClick: () => actions.changeTab('Opinie o treningach', dispatch, setActiveTab),
    toggleActive: true,
  },
];

// Konfiguracja prawej strony
export const rightSideConfig = (searchValue, dispatch) => [
  {
    component: CustomInput,
    props: {
      icon: SearchIcon,
      placeholder: 'Wyszukaj',
      hoverClass: 'hover-effect',
      borders: 'LRBT',
      bordersClassPrefix: 'border-black-',
      baseClass: 'custom-input',
      activeClass: '',
      value: searchValue,
      onChange: (e) => {
        e.preventDefault();
        let value = e.target.value;
        dispatch(setSearchValueT(value)); // Ustaw wartość wyszukiwania w stanie lokalnym
        if (value.length >= 3 ) {
          dispatch(setKeywordT(value)); // Aktualizuj stan w Reduxie
        } else {
          dispatch(setKeywordT('')); // Resetuj stan w Reduxie, jeśli mniej niż 3 znaki
        }
      },
    },
  },
];

export const sortButtonsConfig = (dispatch, sort ) => [
  {
    component: CustomButton,
    props: {
      icon: sort === "ORDER_NUMBER" ? NumSort : AlphaSort,          
      name: sort === "ORDER_NUMBER" ? "Ustalona kolejność" : "Alfabetycznie",
      baseClass: 'custom-button-white',
      hoverClass: 'hover-effect',
      activeClass: '',
      borders: 'LRBT',
      onClick: () => {
        // changeSortingListConfiguration(sort === "ORDER_NUMBER" ? "ALPHABETICALLY" : "ORDER_NUMBER");
        // dispatch(setSortListEndpoint(sort === "ORDER_NUMBER" ? "ALPHABETICALLY" : "ORDER_NUMBER"));
      },
      toggleActive: false,
    },
  },
];